import { Component, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { companyStateDataType } from '../../core/models/Interfaces/company';
import { loginStoreData } from '../../core/models/Interfaces/login';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { SharedModule } from '../../shared/shared.module';
import { companyStateData } from '../../state/selectors/companySelectors';
import { loginStateData } from '../../state/selectors/loginSelector';
import { SharedService } from '../../core/services/shared.service';
import { CookieService } from '../../core/services/cookie/cookie.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal.component';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [SharedModule, ButtonComponent, MatMenuModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  userData: loginStoreData | undefined;
  companyData: companyStateDataType | undefined;
  sideNavVisible: boolean = true;
  logoHeader =
    environment?.ENV === 'PROD'
      ? 'DFW Customer Portal'
      : 'DFW Operating Authority Online Portal(DEV)';

  changePasswordDialogRef: MatDialogRef<ChangePasswordModalComponent> | null =
    null;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private store: Store,
    private sharedService: SharedService,
    private cookie: CookieService,
  ) {
    this.store
      .pipe(select(loginStateData))
      .subscribe((data: any) => (this.userData = data));
    this.store
      .pipe(select(companyStateData))
      .subscribe((data) => (this.companyData = data));
  }

  ngOnInit() {
    this.sharedService.sideNavVisible$.subscribe((visible) => {
      this.sideNavVisible = visible;
    });
  }

  logout() {
    localStorage.clear();
    this.cookie.clear();
    this.router.navigate(['./login']);
  }

  onSideNav() {
    this.sharedService.toggleSideNav();
  }

  onMenuKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      (event.target as HTMLElement).click();
    }
  }

  changePassword() {
    this.changePasswordDialogRef = this.dialog.open(
      ChangePasswordModalComponent,
      {
        width: '250px',
        data: {
          title: 'Change Password',
        },
        hasBackdrop: true,
        disableClose: true,
      },
    );
  }
}
